// extracted by mini-css-extract-plugin
module.exports = {"shareBlockShowOnHover":"ShareBlock_shareBlockShowOnHover__014ca","noText":"ShareBlock_noText__rXV6_","mediumIconSize":"ShareBlock_mediumIconSize__mZA_Q"};